import { InputNumber, Space } from '@arco-design/web-react';
import FormModal from '../FormModal';
import type { Ticket } from '../../api/ticket';

export interface TicketLinkModalProps {
  /** 工单详情（标题展示工单号） */
  detail: Ticket | null;
  visible: boolean;
  /** 待关联通话 CDR id（可空） */
  linkCdr?: number;
  /** 待关联在线会话 id（可空） */
  linkChat?: number;
  onCdrChange: (v?: number) => void;
  onChatChange: (v?: number) => void;
  onOk: () => void;
  onCancel: () => void;
}

/**
 * 关联通话/会话弹窗。
 * 两个字段都是业务编号（自增主键），只接受大于 0 的整数；非法值由调用方在提交前拦下并提示，
 * 不用 InputNumber 的 min/precision：那两个属性会在失焦时把输入静默改写成另一个合法编号
 * （-5 变 1），一旦用户没察觉就会关联到错误对象。
 * 清空时 Arco 回调 undefined，原样透传（不可 Number() 成 NaN，NaN 会以 null 落进请求体）。
 */
export default function TicketLinkModal({
  detail,
  visible,
  linkCdr,
  linkChat,
  onCdrChange,
  onChatChange,
  onOk,
  onCancel,
}: TicketLinkModalProps) {
  return (
    <FormModal
      title={`关联通话/会话 #${detail?.id ?? ''}`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <InputNumber
          data-unit="none"
          style={{ width: '100%' }}
          placeholder="通话 CDR id（可空）"
          value={linkCdr}
          onChange={(v) => onCdrChange(v as number | undefined)}
        />
        <InputNumber
          data-unit="none"
          style={{ width: '100%' }}
          placeholder="在线会话 id（可空）"
          value={linkChat}
          onChange={(v) => onChatChange(v as number | undefined)}
        />
      </Space>
    </FormModal>
  );
}
